import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useEffect } from 'react';
function useDebouncedState(defaultValue, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    leading: false
  };
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var timeoutRef = useRef(null);
  var leadingRef = useRef(true);
  var clearTimeout = function clearTimeout() {
    return window.clearTimeout(timeoutRef.current);
  };
  useEffect(function () {
    return clearTimeout;
  }, []);
  var debouncedSetValue = function debouncedSetValue(newValue) {
    clearTimeout();
    if (leadingRef.current && options.leading) {
      setValue(newValue);
    } else {
      timeoutRef.current = window.setTimeout(function () {
        leadingRef.current = true;
        setValue(newValue);
      }, wait);
    }
    leadingRef.current = false;
  };
  return [value, debouncedSetValue];
}
export { useDebouncedState };